import React, { Component } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { TableListComp, DeletePopUp, EmptyCollection, PageLoader } from '../../../../shared_elements';
import { Header, EditSidebar, ContractHeadertext, CtrTableHd, ContractSideBar, FormModeType } from '../../../../applications/contracts/Elements';
import { ContractWrapper, LeaseDetialTab } from '../../../Elements';
import { STableLoader } from '../../../../shared_elements/loaders';
import { getRelatedLoanListApi,deleteRelatedLoanApi } from '../apiServices';
import { RelatedLoanHd } from '..';
import { sExportContractsAc } from '../../../actionCreators';
import { assetsType } from '../../../../constants';
import { trackActivity } from '../../../../utils_v2/mixpanel';
import { contrHdlineInfoAc } from '../../../../applications/contracts/HeadlinesInfo/actionCreators';
import { titanInstance } from '../../../../shared_elements/components';
import RoleBasedAccess from '../../../../utils/RoleBasedAccess';
import { checkPermission } from '../../../../utils_v2';
import RealatedLoanList from '../components/RelatedLoanList';
import RealatedLoanCRU from '../components/RealatedLoanCRU';
class RealatedLoan extends Component {
  constructor(props){
    super(props);
    this.state = {
      skeletonLoader: true,
      pageLoader: false,
      list:[],
      deleteItem:{modal:false, data:null}
    }
    this.getRelatedLoanListApi = getRelatedLoanListApi.bind(this);
    this.deleteRelatedLoanApi = deleteRelatedLoanApi.bind(this);
  }
  componentDidMount(){
    this.getRelatedLoanListApi(this.props);
    this.props.fetchContractInfo();
    trackActivity('Lease Management', {
      page_title: 'Exceptions to Acceptance',
      event_type: 'Page Visited'
    })
  }
  
  getResponseBack = () => {
    this.getRelatedLoanListApi(this.props);
  }
  changeMsn =(evt) =>{
    let url = '/'+assetsType[evt.asset_type]+'/'+evt.slug+'/contracts';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  render(){
    const { list, skeletonLoader, pageLoader, deleteItem } = this.state;
    const { params, contractSummaryLoader, contractInfo } = this.props;
    return(
      <div className="contract-container">
        <Header type="brief" headingText="Lease Management" params= {this.props.params} changeMsn={this.changeMsn} exportContract={this.props.exportContract} />
        <ContractSideBar application="WetLeases" type="brief" params={this.props.params} />
        <div className="contract-content-blk">
          <LeaseDetialTab url='related-loan' primaryTab='basic-betails' secondaryTab='related-loan' />
          <ContractWrapper
            url='audit/contracts/ctrelatedloan/'
            queryParams={{action:0, contract:this.props.params.contract_slug}}
            revision={true}
            params={params}
            buttonText={checkPermission('contracts','related_loan', 'C')?<RealatedLoanCRU getResponseBack={this.getResponseBack} contractInfo={contractInfo}/>:null}
          >
            { skeletonLoader ?
              (<STableLoader count={5} />):
              (
                <TableListComp
                  heads={RelatedLoanHd}
                  data={list?.map((item,index) =>
                    <RealatedLoanList
                      getResponseBack={this.getResponseBack}
                      key={index}
                      item={item} 
                      contractInfo={contractInfo}
                      deletecontibution={() => this.setState({deleteItem:{modal:true, data:item}})}
                      />
                    )
                  }
                  noRecord={ list.length ? null:
                    <EmptyCollection
                      title="No records found"
                    />
                  }
                />
              )
            }
            { pageLoader || contractSummaryLoader ? <PageLoader />:null}
          </ContractWrapper>
        </div>
        { deleteItem.modal?
          <DeletePopUp
            modal={deleteItem.modal}
            toggleModalFn={() => this.setState({deleteItem:{modal:false, data:null}})}
            title="Delete"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.deleteRelatedLoanApi(this.props,deleteItem)}
          />:null
        }
      </div>
    )
  }
}
const mapStateToProps = state => ({
  contractSummaryLoader: state.contractReducer.contractSummaryLoader,
  contractInfo: state.ContrHdlineReducer.contrHdlineInfo,
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    exportContract : (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
    fetchContractInfo: () => dispatch(contrHdlineInfoAc(ownProps.params)),
  } 
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(RealatedLoan,['contracts', 'related_loan' ,'R'])))
